import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { MssFieldBaseFieldTypeComponent } from '../mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';

@Component({
  templateUrl: 'number.component.html',
  imports: [
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    ...MSS_FORMLY_IMPORTS,
  ],
})
export class NumberFieldTypeComponent extends MssFieldBaseFieldTypeComponent {
  public static defaultOptions: FormlyFieldConfig = {
    props: {
      ...MssFieldBaseFieldTypeComponent.focusBlurZeroDefault,
    },
  };

  public preventUnwanted(event) {
    if (event.key === 'e' || (!this.props.allowDecimal && event.key === '.')) {
      event.preventDefault();
    }
  }
}
